module.exports = __webpack_public_path__ + "media/images/flags/ky-027ef2b4fb6d82652c1b4ea5277bfc77.svg";